<template>
  <div ref="parent" class="home-container">
   <el-carousel height= "45vw" autoplay >
        <el-carousel-item v-for="item in imgs" :key="item">
          <img :src="item" style="width: 100%;height: auto">
        </el-carousel-item>
   </el-carousel>
    <p class="p2">青海民族服饰简介</p>
    <div v-if="!isNavCollapsed" class="about-us">
      <div class="team-intro">
        <p class="p1">青海是一个多民族的省份，有藏族、回族、土族、撒拉族、保安族、东乡族、门巴族、珞巴族等十几个少数民族，他们的服饰文化是中华民族服饰文化的重要组成部分，具有丰富的历史、地域、民族、宗教等特色，反映了他们的生产生活、审美情趣、文化心态、社会习俗等方面的信息，是青海的一张亮丽的名片。</p>
        <p class="p1"> 随着社会的发展和时代的变化，少数民族的服饰文化面临着保护、传承、创新的挑战，如何利用现代科技手段，将少数民族的服饰文化展示给更多的人，提高其知名度和影响力，促进其与其他文化的交流和融合，是一个亟待解决的问题。</p>
        <p class="p1">为此，我们提出了建立一个青海民族服饰展示系统的设想，该系统旨在利用数字化、多媒体、虚拟现实等技术，将青海各少数民族的服饰文化进行数字化采集、存储、处理、展示，形成一个集信息查询、云端试穿、线下体验、文化传播等功能于一体的综合平台，为青海民族服饰文化的保护、传承、创新、推广提供一个有效的途径。
        </p>
      </div>
      <div class="team-image">
        <img src="../../assets/svg/zangzu.jpg" >
      </div>
    </div>
    <div v-else >

        <p class="p1">青海是一个多民族的省份，有藏族、回族、土族、撒拉族、保安族、东乡族、门巴族、珞巴族等十几个少数民族，他们的服饰文化是中华民族服饰文化的重要组成部分，具有丰富的历史、地域、民族、宗教等特色，反映了他们的生产生活、审美情趣、文化心态、社会习俗等方面的信息，是青海的一张亮丽的名片。</p>
        <p class="p1"> 随着社会的发展和时代的变化，少数民族的服饰文化面临着保护、传承、创新的挑战，如何利用现代科技手段，将少数民族的服饰文化展示给更多的人，提高其知名度和影响力，促进其与其他文化的交流和融合，是一个亟待解决的问题。</p>
        <p class="p1">为此，我们提出了建立一个青海民族服饰展示系统的设想，该系统旨在利用数字化、多媒体、虚拟现实等技术，将青海各少数民族的服饰文化进行数字化采集、存储、处理、展示，形成一个集信息查询、云端试穿、线下体验、文化传播等功能于一体的综合平台，为青海民族服饰文化的保护、传承、创新、推广提供一个有效的途径。
        </p>


        <img src="../../assets/svg/zangzu.jpg" style="width: 100%;height: auto">

    </div>
    <template>
      <el-card style="max-width: 100%;background-color: #c5c5c5" >
<!--        <div style="text-align: center; padding: 10px ">
          <el-link type="info" href="/front/about">关于我们</el-link>    |
          <el-link type="info">联系我们</el-link>    |
          <el-link type="info">免责声明</el-link>
        </div>-->
        <div class="links-container">
          <a class="link-item" href="/front/about">关于我们</a>
          <span class="separator">|</span>
          <a class="link-item" href="/front/message">联系我们</a>
          <span class="separator">|</span>
          <a class="link-item" href="/front/toldyou">免责声明</a>
        </div>

        <p style="text-align: center; ">邮箱：1806186849@qq.com</p>
        <p style="text-align: center; ">电话：1806186849</p>
        <p style="text-align: center; ">@2022-2024 版权所有 青海师范大学 · 非物质文化遗产保护</p>
        <p style="text-align: center; color: #d63031">建议使用360极速、Chrome、Firefox浏览器，最佳分辨率1920×1080</p>
      </el-card>
    </template>


  </div>
</template>

<script>
import CryptoJS from 'crypto-js';
export default {
  name: "FrontHome",
  data() {
    return {
      isNavCollapsed: true, // 控制导航栏是否折叠
      isNavExpanded: false, // 控制下拉菜单是否展开
      parentWidth: window.innerWidth, // 初始宽度，将在mounted中更新
      inputText: '',
      encryptedText: '',
      decryptedText: '',
      secretKey: '2b7e151628aed2a6abf7158809cf4f3c', // 替换为你的密钥
      imgs:[],
    }
  },
  created() {
    this.load()
  },
  mounted() {
    // 页面加载时从localStorage中读取状态
    window.addEventListener('resize', this.updateParentWidth);
    this.updateParentWidth();
  },
  methods:{
    handleNavClick(item) {
      // 处理导航按钮点击事件
      console.log(`Clicked: ${item.label}`);
      // 如果需要关闭下拉菜单，可以在这里设置 isNavExpanded = false;
    },
    updateParentWidth() {
      this.parentWidth = this.$refs.parent.offsetWidth;
      this.checkNavCollapse();
    },
    checkNavCollapse() {
      this.isNavCollapsed = this.parentWidth < 500;
    },
    encryptText() {
      const ciphertext = CryptoJS.AES.encrypt('000000', '2b7e151628aed2a6abf7158809cf4f3c').toString();
      console.log(ciphertext)
      this.encryptedText = ciphertext;
      this.decryptedText = ''; // 清空解密后的文本
    },
    decryptText() {
      const bytes = CryptoJS.AES.decrypt(this.encryptedText, this.secretKey);
      const originalText = bytes.toString(CryptoJS.enc.Utf8);
      this.decryptedText = originalText;
      this.inputText = originalText; // 将解密后的文本设置回输入框，便于查看
    },
    load(){
      this.request.get('/banner').then(res=>{
        this.imgs = res.data.map(item=>item.img)
      })
    }
  },
};
</script>

<style lang="scss">
.home-container {
  padding-top: 0;
}
.center-block {
  margin-left: auto;
  margin-right: auto;
  width: 50%; /* 或者具体的像素值 */
}
.p2 {
  font-family: Serif;
  font-size: 25px;
  padding-left: 17%;
  font-weight: bold;
  color: #666666;
}
.p1 {
  color: #666666;
  font-family: 华文中宋;
  font-size: 18px;
  margin-bottom: 20px;
  padding-left: 15%;  /* 设置左内边距为父元素宽度的10% */
  padding-right: 15%; /* 设置右内边距为父元素宽度的10% */
}
.about-us {
  display: flex;
  justify-content: space-between; /* 水平和平分配空间 */
  align-items: center; /* 垂直居中 */
  padding: 20px; /* 添加一些内边距 */
}

.team-intro {
  flex: 1; /* 占据剩余空间的一部分 */
  text-align: left; /* 文本靠左对齐 */
}

.team-image {
  flex: 1; /* 占据剩余空间的一部分 */
  //text-align: right; /* 图片靠右对齐（虽然这里用不到，但保持一致性） */
}

.team-image img {
  max-width: 100%; /* 图片最大宽度为容器宽度 */
  height: auto; /* 图片高度自动调整 */
}
.links-container {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中（如果需要的话） */
}

.link-item {
  margin: 0 5px; /* 文本之间的间隔 */
}

.separator {
  color: #999; /* 分隔符颜色，可以根据需要调整 */
  margin: 0 5px; /* 分隔符与文本之间的间隔 */
}
</style>
